export default __webpack_public_path__ + "static/media/dr-vandana.8b98c7b6.jpg";